import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DragSource } from 'react-dnd';
import styled from 'styled-components';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardHero from 'UIComponents/card/UICardHero';
import UIImage from 'UIComponents/image/UIImage';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { openDeleteSectionModal } from 'ContentEditorUI/redux/actions/inpageActions';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { GYPSUM } from 'HubStyleTokens/colors';
import UIDescriptionList from 'UIComponents/list/UIDescriptionList';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import InpageSectionTag from './InpageSectionTag';
import { getSidebarIframeWindow } from 'InpageEditorUI/lib/domUtils/sidebarIframeDomUtils';
import { isEmbed as isEmbedTypeGuard, isFixedLayoutSection, isSavedSection as isSavedSectionTypeGuard } from 'ContentEditorUI/types/Section';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DraggableSectionTypes = {
  MARKETER: 'marketer',
  DEVELOPER: 'developer',
  EMBED: 'embed'
};
const getDraggableSectionType = section => {
  if (isEmbedTypeGuard(section)) {
    return DraggableSectionTypes.EMBED;
  }
  if (isSavedSectionTypeGuard(section)) {
    return DraggableSectionTypes.MARKETER;
  }
  return DraggableSectionTypes.DEVELOPER;
};
const DeleteSectionButton = ({
  sectionId
}) => {
  const sidebarIframeWindow = getSidebarIframeWindow();
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsx(UIIconButton, {
    className: "m-left-auto hs-allow-transition delete-saved-section-icon-button",
    use: "unstyled",
    tooltip: "Delete",
    onClick: () => {
      dispatch(openDeleteSectionModal(sectionId));
    },
    tooltipProps: {
      _bodyElement: sidebarIframeWindow.document.body
    },
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "delete"
    })
  });
};
const moduleSource = {
  beginDrag(props) {
    const dragPayload = {
      // Little bit of coupling here as embeds and custom sections both have `id`s
      customSectionId: props.section.id,
      sectionTree: props.section.sectionTree,
      type: 'customSection',
      isColumn: false,
      isRow: true,
      isTopMostRow: true,
      isEmbed: isEmbedTypeGuard(props.section),
      isMarketerSection: isSavedSectionTypeGuard(props.section),
      sectionName: props.section.name,
      sectionLabel: props.section.label,
      themePath: props.themePath
    };
    props.onDragStart(dragPayload);
    return dragPayload;
  },
  endDrag(props, monitor) {
    const dropResult = monitor.getDropResult();
    const dragItem = monitor.getItem();
    if (!monitor.didDrop()) {
      props.onDragEnd(undefined, dragItem);
      return;
    }
    props.onDragEnd(dropResult, dragItem);
  }
};
const Draggable = DragSource(DRAG_TYPES.CUSTOM_SECTION, moduleSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
}));
const Paragraph = styled.span.withConfig({
  displayName: "InpageDraggableSection__Paragraph",
  componentId: "sc-1kvtrkt-0"
})([".hs-private.hs-private.hs-private &{}"]);
const ListContainer = styled.div.withConfig({
  displayName: "InpageDraggableSection__ListContainer",
  componentId: "sc-1kvtrkt-1"
})([".hs-private.hs-private.hs-private &{display:grid;grid-auto-flow:column;grid-template-columns:5fr 5fr 4fr;grid-gap:auto;}"]);
const MockImageContainer = styled.div.withConfig({
  displayName: "InpageDraggableSection__MockImageContainer",
  componentId: "sc-1kvtrkt-2"
})([".hs-private.hs-private.hs-private &{display:flex;justify-content:center;width:100%;background-color:", ";padding:5px 100px;}"], GYPSUM);
const EmbedContent = ({
  updatedByName,
  updatedAt,
  pageCount
}) => {
  return /*#__PURE__*/_jsx(UIDescriptionList, {
    children: /*#__PURE__*/_jsxs(ListContainer, {
      className: "m-top-3",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "addSectionPanel.customSections.embedDescriptionList.lastUpdatedBy"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: updatedByName
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "addSectionPanel.customSections.embedDescriptionList.lastUpdatedOn"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: updatedAt,
            format: "short-date"
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "addSectionPanel.customSections.embedDescriptionList.embeddedIn"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "addSectionPanel.customSections.embedDescriptionList.assetCount",
            options: {
              count: pageCount
            }
          })
        })]
      })]
    })
  });
};
const InpageSection = ({
  section,
  sectionType
}) => {
  const [isWiggly, setIsWiggly] = useState(false);
  const toggleWiggleCard = () => {
    setIsWiggly(!isWiggly);
  };
  const imageAltText = section.description || I18n.text('addSectionPanel.sectionAltText');
  const classNames = 'hs-allow-transition card-item m-bottom-0';
  const isEmbed = isEmbedTypeGuard(section);
  const isMarketer = isSavedSectionTypeGuard(section);
  return /*#__PURE__*/_jsx("div", {
    onClick: toggleWiggleCard,
    onAnimationEnd: toggleWiggleCard,
    children: /*#__PURE__*/_jsxs(UICardWrapper, {
      compact: true,
      className: isWiggly ? `${classNames} wiggly-section` : classNames,
      children: [/*#__PURE__*/_jsxs(UICardHero, {
        className: "patagonia-section-image",
        children: [!isEmbed && /*#__PURE__*/_jsx(UIImage, {
          alt: imageAltText,
          src: section.screenshotUrl
        }), isEmbed && /*#__PURE__*/_jsx(MockImageContainer, {
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "mobile-onboarding-embed-tracking-code"
          })
        })]
      }), /*#__PURE__*/_jsxs(UICardSection, {
        className: "p-top-0 m-top-3 p-bottom-3",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "display-flex align-center m-bottom-2",
          children: [/*#__PURE__*/_jsx(UITruncateMultiline, {
            tagName: "strong",
            "data-test-id": `${sectionType}-section-label`,
            text: section.label || section.name,
            maxChars: section.isSmart ? 40 : 60,
            Paragraph: Paragraph
          }), isMarketer && /*#__PURE__*/_jsx(DeleteSectionButton, {
            sectionId: section.id
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "display-flex align-center",
          children: [isMarketer && section.isSmart && /*#__PURE__*/_jsx(InpageSectionTag, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "addSectionPanel.customSections.smart"
            }),
            helpTitle: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "addSectionPanel.customSections.smartSectionInfo"
            })
          }), isFixedLayoutSection(section) && /*#__PURE__*/_jsx(InpageSectionTag, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "addSectionPanel.customSections.fixedLayout"
            }),
            helpTitle: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "addSectionPanel.customSections.fixedLayoutLayoutInfo"
            })
          }), isEmbed && /*#__PURE__*/_jsx(InpageSectionTag, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "addSectionPanel.customSections.embed"
            }),
            helpTitle: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "addSectionPanel.customSections.embedInfo"
            })
          })]
        }), isEmbed && /*#__PURE__*/_jsx(EmbedContent, {
          updatedAt: section.updatedAt,
          updatedByName: section.updatedByName,
          pageCount: section.pageCount
        }), !isEmbed && section.description && /*#__PURE__*/_jsx("p", {
          className: "m-top-2",
          children: section.description
        })]
      })]
    })
  });
};
function InpageDraggableSection({
  section,
  connectDragSource,
  isDraggable = true,
  notAddableMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.layout.addSection.genericNotAddable"
  })
}) {
  const sectionType = getDraggableSectionType(section);
  const sectionElement = /*#__PURE__*/_jsx("div", {
    "data-hs-dragdrop": true,
    "data-test-id": `${sectionType}-section-${section.label || section.name}`,
    className: "custom-section-card",
    style: {
      cursor: `${isDraggable ? 'grab' : 'not-allowed'}`
    },
    children: /*#__PURE__*/_jsx(InpageSection, {
      section: section,
      sectionType: sectionType,
      isDraggable: isDraggable
    })
  }, `section-${section.id}`);
  if (isDraggable) {
    return connectDragSource(sectionElement);
  }
  const sidebarIframeWindow = getSidebarIframeWindow();
  return /*#__PURE__*/_jsx(UITooltip
  // @ts-expect-error _bodyElement is not documented as a prop to UITooltip
  , {
    _bodyElement: sidebarIframeWindow.document.body,
    use: "longform",
    title: notAddableMessage,
    children: /*#__PURE__*/_jsxs("div", {
      className: "disabled-custom-section-card",
      children: [sectionElement, /*#__PURE__*/_jsx("div", {
        className: "disabled-custom-section-card-overlay"
      })]
    })
  });
}

// @ts-expect-error The `Section` type doesn't play well with
// PropTypes.object.isRequired, since it seems that Draggable needs parity
// between the component property types and the PropTypes. I'm omitting updating
// this for now.
export default Draggable(InpageDraggableSection);
InpageDraggableSection.propTypes = {
  section: PropTypes.object.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  isDraggable: PropTypes.bool,
  onDragStart: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired
};